import { styled } from "@mui/material/styles";

export const LinkWrapper = styled("span")(() => ({
  "& a": {
    display: "inline-block",
  },
}));
